import { BaseApi } from "./BaseApi";
import {Obra} from "../../types/Obra";

export class ObraApi extends BaseApi {
    constructor() {
        super();
    }

    async obterObras(oidCliente: number) : Promise<Obra[]> {
        return (await this.api.get(`/Orcamento/ObterObrasClientePedido`, {
            params: {
                oidCliente
            }
        })).data
    }
}
